export const UPLOAD_INSTRUMENT = 'upload.instrument';
export const UPLOAD_CLEAR = 'upload.clear';
export const UPLOAD_INVALID_FILE_SELECTED = 'upload.invalidFile';
